import * as i0 from '@angular/core';
import { Injectable, EventEmitter, ViewChild, Output, Input, Component, NgModule } from '@angular/core';
import { Subject, firstValueFrom } from 'rxjs';
import * as i1 from '@azavista/components/shared';
import { delay, pick, AzavistaSharedModule } from '@azavista/components/shared';
import * as i3 from '@angular/common';
import * as i4 from '@ngx-translate/core';
import * as i5 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i6 from '@azavista/components/input-field';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import * as i7 from '@angular/material/input';
import * as i8 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import * as i9 from '@azavista/components/selected-items-count';
import { AzavistaSelectedItemsCountModule } from '@azavista/components/selected-items-count';
import { MatDividerModule } from '@angular/material/divider';
const _c0 = ["groupsContainer"];
function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_azavista_input_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 15, 1);
    i0.ɵɵlistener("valueChanged", function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_azavista_input_field_1_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCellValueChanged(item_r2, $event));
    })("relationSearchTextChanged", function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_azavista_input_field_1_Template_azavista_input_field_relationSearchTextChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onRelationSearchTextChanged(item_r2, $event));
    })("autocompleteSearchTextChanged", function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_azavista_input_field_1_Template_azavista_input_field_autocompleteSearchTextChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onAutocompleteSearchTextChanged(item_r2, $event));
    })("invalidValueSet", function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_azavista_input_field_1_Template_azavista_input_field_invalidValueSet_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCellInvalidValueSet(item_r2, $event));
    })("editModeEntered", function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_azavista_input_field_1_Template_azavista_input_field_editModeEntered_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.switchAllFieldsToEditMode());
    })("croppedImageUploaded", function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_azavista_input_field_1_Template_azavista_input_field_croppedImageUploaded_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onCroppedImageUploaded(item_r2, $event));
    })("documentSelected", function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_azavista_input_field_1_Template_azavista_input_field_documentSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const item_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onDocumentSelected(item_r2, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const inputField_r4 = i0.ɵɵreference(1);
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const group_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("field", (item_r2.field == null ? null : item_r2.field.customFieldByEntityValue) ? ctx_r2.getDynamicFieldAndUpdateValidity(item_r2.field, inputField_r4) : item_r2.field)("value", item_r2.value)("label", item_r2.field.label)("showLabelInReadonlyMode", true)("showLabelForBooleans", true)("canEdit", !ctx_r2.editDisabled && !group_r5.readOnly)("editMode", ctx_r2.data.editModeForAllFields && !group_r5.readOnly)("fullWidth", true)("fieldAppearance", ctx_r2.fieldAppearance)("options", item_r2.options)("setImageFieldData", ctx_r2.setImageFieldDataSubject)("setDocumentFieldData", ctx_r2.setDocumentFieldDataSubject)("setTextFieldValue", ctx_r2.setTextFieldValueSubject)("textAreaOptions", ctx_r2.data.textAreaOptions)("floatLabel", ctx_r2.floatLabel)("isTouched", ctx_r2.forceAllFieldToBeTouched);
  }
}
function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
}
function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_azavista_input_field_1_Template, 2, 16, "azavista-input-field", 13)(2, AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_span_2_Template, 1, 0, "span", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r2.field);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r2.field);
  }
}
function AzavistaGroupedFieldsComponent_mat_expansion_panel_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-expansion-panel", 9)(1, "mat-expansion-panel-header")(2, "mat-panel-title", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵtemplate(5, AzavistaGroupedFieldsComponent_mat_expansion_panel_3_ng_container_5_Template, 3, 2, "ng-container", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const group_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("expanded", ctx_r2.data.expandPanels);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(group_r5.key || "");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("fields-container", !ctx_r2.data.singleColumn)("aza-cmp-full-column-half-row-gap", !ctx_r2.data.singleColumn)("fields-container-single-column", ctx_r2.data.singleColumn)("aza-cmp-half-gap", ctx_r2.data.singleColumn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", group_r5.items);
  }
}
function AzavistaGroupedFieldsComponent_div_4_ng_container_2_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const fieldWithValue_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", fieldWithValue_r6.field.label, ", ");
  }
}
function AzavistaGroupedFieldsComponent_div_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 17);
    i0.ɵɵtext(2, "THE_FOLLOWING_FIELDS_HAVE_ERRORS");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, ": ");
    i0.ɵɵtemplate(4, AzavistaGroupedFieldsComponent_div_4_ng_container_2_span_4_Template, 2, 1, "span", 18);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r2.invalidFieldsWithValues);
  }
}
function AzavistaGroupedFieldsComponent_div_4_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.externalErrorData == null ? null : ctx_r2.externalErrorData.errorText);
  }
}
function AzavistaGroupedFieldsComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "mat-error");
    i0.ɵɵtemplate(2, AzavistaGroupedFieldsComponent_div_4_ng_container_2_Template, 5, 1, "ng-container", 14)(3, AzavistaGroupedFieldsComponent_div_4_div_3_Template, 3, 1, "div", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r2.invalidFieldsWithValues == null ? null : ctx_r2.invalidFieldsWithValues.length) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.externalErrorData == null ? null : ctx_r2.externalErrorData.hasError);
  }
}
function AzavistaGroupedFieldsComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
  }
}
function AzavistaGroupedFieldsComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "azavista-button", 23);
    i0.ɵɵlistener("click", function AzavistaGroupedFieldsComponent_div_9_Template_azavista_button_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onSave());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "uppercase");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "azavista-button", 24);
    i0.ɵɵlistener("click", function AzavistaGroupedFieldsComponent_div_9_Template_azavista_button_click_6_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onCancel());
    });
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵpipe(10, "uppercase");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("float-actions", ctx_r2.floatActions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.actionButtonsDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 8, i0.ɵɵpipeBind1(4, 6, "SAVE")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r2.actionButtonsDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 12, i0.ɵɵpipeBind1(9, 10, "CANCEL")));
  }
}
let AzavistaGroupedFieldsService = /*#__PURE__*/(() => {
  class AzavistaGroupedFieldsService {
    constructor(sharedSvc) {
      this.sharedSvc = sharedSvc;
    }
    sortGroups(groups, singleColumn) {
      groups.sort((left, right) => left.key.localeCompare(right.key));
      for (const group of groups) {
        group.items.sort((left, right) => left.field.label.localeCompare(right.field.label));
        if (!singleColumn) {
          // Two columns must show items by columns - when the first colulmn shows the half of the fields,
          // the rest should be shown on the second column
          // So instead of the followig natural CSS grid ordering with two columns:
          // Field1    Field2
          // Field3    Field4
          // Field5
          // In an array - [Field1, Field2, Field3, Field4, Field5]
          // We need to order them by columns like:
          // Field1    Field4
          // Field2    Field5
          // Field3
          // in an array - [Field1, Field4, Field2, Field5, Field3]
          group.items = this.orderItemsByTwoColumns(group.items);
        }
      }
    }
    orderItemsByTwoColumns(items) {
      const ordered = [...items];
      const result = [];
      const itemsInColumn = Math.ceil(items.length / 2);
      for (let i = 0; i < itemsInColumn; i++) {
        result.push(ordered[i]);
        const secondColumnIndex = i + itemsInColumn;
        if (secondColumnIndex < ordered.length) {
          result.push(ordered[secondColumnIndex]);
        }
      }
      return result;
    }
    getFieldWithValueInGroups(fieldId, groups) {
      for (const group of groups) {
        const fieldWithValue = group.items.find(x => x.field.id === fieldId);
        if (fieldWithValue) {
          return fieldWithValue;
        }
      }
      return null;
    }
    getObjectEnumOriginalValues(changesOnlyObject, fieldsWithEntity) {
      if (!fieldsWithEntity.fields || !changesOnlyObject) {
        return {};
      }
      const changedObjectProps = Object.keys(changesOnlyObject);
      const changedObjectEnumFields = fieldsWithEntity.fields.filter(x => this.sharedSvc.getFieldTypeFromField(x) === 'virtual-object_enum' && changedObjectProps.find(y => y === x.name));
      // Set all object_enum field values in entity "selected" to the item with new reported property
      const objectEnumFieldValues = {};
      for (const changedObjectEnumField of changedObjectEnumFields) {
        const fieldName = changedObjectEnumField.name;
        const entityValue = fieldsWithEntity.entity[fieldName];
        if (entityValue && entityValue.items) {
          const reportProp = entityValue.reportProperty;
          if (reportProp) {
            const changedFieldValue = changesOnlyObject[fieldName];
            entityValue.selected = entityValue.items.find(x => x[reportProp] === changedFieldValue);
            objectEnumFieldValues[fieldName] = entityValue;
          }
        }
      }
      return objectEnumFieldValues;
    }
    createObjectFromChanges(changes) {
      if (!changes || changes.length === 0) {
        return null;
      }
      const result = {};
      for (const change of changes) {
        result[change.field.name] = change.value;
      }
      return result;
    }
    addChange(fieldWithValue, change, changes) {
      // const areValuesEqual = this.sharedSvc.areValuesEqual(change.originalValue, change.value);
      const existingIndex = changes.findIndex(x => x.field === fieldWithValue.field);
      // if (areValuesEqual) {
      //     if (existingIndex >= 0) {
      //         // The values are equal and we have that item (probably it was changed and now changed back to original)
      //         // Remove the item
      //         changes.splice(existingIndex, 1);
      //     }
      //     // In any case if the values are equal, we do not add new or change existing
      //     return;
      // }
      if (existingIndex >= 0) {
        // This field already exists - change it
        changes[existingIndex] = change;
      } else {
        // This field does not exist in the list - add it
        changes.push(change);
      }
    }
    setError(field, changes) {
      const existingIndx = changes.findIndex(x => x.field === field);
      if (existingIndx >= 0) {
        // The field with error is found in changes - remove it since error value is not considered a valid change
        changes.splice(existingIndx, 1);
      }
    }
    createGroups(groupedFields, entity, fieldsOptions) {
      const result = [];
      for (const grp of groupedFields) {
        result.push({
          key: grp.key,
          items: this.createGroupItems(grp.items, entity, fieldsOptions)
        });
      }
      return result;
    }
    createGroupItems(fields, entity, fieldsOptions) {
      const result = [];
      for (const field of fields) {
        const fieldWithValue = {
          field: field,
          value: entity[field.name]
        };
        if (fieldsOptions) {
          const fieldOptions = fieldsOptions.find(x => x.fieldId === field.id);
          if (fieldOptions) {
            fieldWithValue.options = fieldOptions.options;
          }
        }
        result.push(fieldWithValue);
      }
      return result;
    }
    static {
      this.ɵfac = function AzavistaGroupedFieldsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaGroupedFieldsService)(i0.ɵɵinject(i1.AzavistaSharedService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaGroupedFieldsService,
        factory: AzavistaGroupedFieldsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaGroupedFieldsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaGroupedFieldsComponent = /*#__PURE__*/(() => {
  class AzavistaGroupedFieldsComponent {
    constructor(sharedSvc, grpFldsSvc, cdr, ngZone) {
      this.sharedSvc = sharedSvc;
      this.grpFldsSvc = grpFldsSvc;
      this.cdr = cdr;
      this.ngZone = ngZone;
      this.actionButtonsDisabled = false;
      this.progressText = '';
      this.floatActions = true;
      this.valuesChanged = new EventEmitter();
      this.cancelled = new EventEmitter();
      this.saved = new EventEmitter();
      this.relationSearchTextChanged = new EventEmitter();
      this.autocompleteSearchTextChanged = new EventEmitter();
      this.croppedImageUploaded = new EventEmitter();
      this.documentSelected = new EventEmitter();
      this.hasChanges = false;
      /** Validated Value-changes */
      this.changes = [];
      this.editDisabled = false;
      this.invalidFieldsWithValues = [];
      this.showActionButtons = false;
      this.setImageFieldDataSubject = new Subject();
      this.setDocumentFieldDataSubject = new Subject();
      this.forceAllFieldToBeTouched = false;
      this.setTextFieldValueSubject = new Subject();
      this.subscriptions = [];
    }
    ngOnChanges(changes) {
      if (changes.data?.currentValue) {
        this.dataChanged(changes.data.currentValue);
        this.setShowActionButtonsFlag();
      }
      if (changes.acl) {
        this.editDisabled = !this.sharedSvc.hasAccess(this.acl);
        this.setShowActionButtonsFlag();
      }
      if (changes.customSections) {
        this.applyCustomViewSections();
      }
    }
    ngOnInit() {
      if (this.acknowledgeEntity) {
        this.acknowledgeEntitySubscription = this.acknowledgeEntity.subscribe({
          next: entity => this.processAcknowledgeEntity(entity)
        });
        this.subscriptions.push(this.acknowledgeEntitySubscription);
      }
      if (this.changeFieldValue) {
        this.subscriptions.push(this.changeFieldValue.subscribe({
          next: data => this.processChangeFieldValue(data)
        }));
      }
      if (this.setImageFieldData) {
        this.subscriptions.push(this.setImageFieldData.subscribe({
          next: data => this.setImageFieldDataSubject.next(data)
        }));
      }
      if (this.setDocumentFieldData) {
        this.subscriptions.push(this.setDocumentFieldData.subscribe({
          next: data => this.setDocumentFieldDataSubject.next(data)
        }));
      }
      if (this.setExternalError) {
        this.subscriptions.push(this.setExternalError.subscribe({
          next: data => this.processSetExternalError(data)
        }));
      }
      if (this.performSave) {
        this.subscriptions.push(this.performSave.subscribe(() => this.onSave()));
      }
    }
    processSetExternalError(data) {
      this.externalErrorData = data;
      this.setHasError();
    }
    processChangeFieldValue(data) {
      const fieldWithValue = this.grpFldsSvc.getFieldWithValueInGroups(data.fieldId, this.groups);
      if (!fieldWithValue) {
        return;
      }
      fieldWithValue.value = data.value;
      const fieldType = this.sharedSvc.getFieldTypeFromField(fieldWithValue.field);
      const textFieldTypes = ['text', 'virtual-textarea', 'email', 'url'];
      const isFieldTextType = textFieldTypes.includes(fieldType);
      if (isFieldTextType) {
        this.setTextFieldValueSubject.next({
          fieldId: fieldWithValue.field.id,
          value: data.value
        });
      }
      this.onCellValueChanged(fieldWithValue, {
        field: fieldWithValue.field,
        value: fieldWithValue.value
      });
    }
    processAcknowledgeEntity(entity) {
      this.data.editModeForAllFields = false;
      if (entity) {
        // Specific entity is sent - use it
        this.data.fieldsWithEntity.entity = entity;
      } else {
        // Entity is not sent - use original one and apply changes to it
        const changesOnlyObject = this.grpFldsSvc.createObjectFromChanges(this.changes);
        // object_enum fields which report specific property, must use original value
        // otherwise setting simply string value to entity will break object items of the field
        // Set all object_enum field values in entity "selected" to the item with new reported property
        const objectEnumFieldValues = this.grpFldsSvc.getObjectEnumOriginalValues(changesOnlyObject, this.data.fieldsWithEntity);
        const wholeEntityWithChanges = Object.assign(this.data.fieldsWithEntity.entity, changesOnlyObject);
        this.data.fieldsWithEntity.entity = Object.assign(wholeEntityWithChanges, objectEnumFieldValues);
      }
      this.forceAllFieldToBeTouched = false;
      this.dataChanged(this.data);
      this.changes = [];
      this.setHasChanges();
    }
    dataChanged(data) {
      this.originalFieldsWithEntity = this.sharedSvc.clone(data.fieldsWithEntity);
      this.restoreReferencesAfterClone(this.originalFieldsWithEntity, data.fieldsWithEntity);
      const changedData = data;
      const groupedFields = this.sharedSvc.getGroups(changedData.fieldsWithEntity.fields, x => x.category || '');
      const groups = this.grpFldsSvc.createGroups(groupedFields, changedData.fieldsWithEntity.entity, changedData.fieldsOptions);
      if (!data.disableAutoOrdering) {
        this.grpFldsSvc.sortGroups(groups, data.singleColumn);
      }
      this.calculatedGroups = groups;
      this.groups = groups;
      this.applyCustomViewSections();
    }
    restoreReferencesAfterClone(clonedFieldsWithEntity, fieldsWithEntity) {
      for (const field of fieldsWithEntity.fields) {
        if (field.component === "object_enum" /* FieldComponentType.objectEnum */) {
          const objectEnumValue = clonedFieldsWithEntity.entity[field.name];
          if (objectEnumValue.items && objectEnumValue.selected) {
            let selectedIndex = objectEnumValue.items.findIndex(x => x === objectEnumValue.selected);
            if (selectedIndex === -1) {
              // Not found by reference, try to find it by id
              selectedIndex = objectEnumValue.items.findIndex(x => x.id === objectEnumValue.selected.id);
              if (selectedIndex >= 0) {
                const clonedObjectEnumValue = clonedFieldsWithEntity.entity[field.name];
                clonedObjectEnumValue.selected = clonedObjectEnumValue.items[selectedIndex];
              }
            }
          }
        }
      }
    }
    applyCustomViewSections() {
      if (!this.customSections || this.customSections.length === 0 || this.data.singleColumn) {
        // Single column mode will not use custom sections for now, because custom sections have 2 columns
        this.groups = this.calculatedGroups;
        return;
      }
      const newGroups = [];
      // Create new groups based on the sections and put fields on appropriate positions
      for (const section of this.customSections) {
        const newGroup = {
          key: section.label,
          items: [],
          readOnly: section.read_only
        };
        const maxItems = Math.max(section.left_column?.length || 0, section.right_column?.length || 0);
        for (let i = 0; i < maxItems; i++) {
          const leftFieldIdOrName = section.left_column ? section.left_column[i] : null;
          const leftFieldWithValue = this.findFieldWithValueByIdOrName(this.calculatedGroups, leftFieldIdOrName);
          const rightFieldIdOrName = section.right_column ? section.right_column[i] : null;
          const rightFieldWithValue = this.findFieldWithValueByIdOrName(this.calculatedGroups, rightFieldIdOrName);
          newGroup.items.push(leftFieldWithValue || {
            field: null
          });
          newGroup.items.push(rightFieldWithValue || {
            field: null
          });
        }
        newGroups.push(newGroup);
      }
      this.groups = newGroups;
    }
    findFieldWithValueByIdOrName(groups, fieldIdOrName) {
      for (const group of groups) {
        let field = group.items.find(x => x.field.id === fieldIdOrName);
        if (!field) {
          // Not found by id - try to find it by name
          field = group.items.find(x => x.field.name === fieldIdOrName);
        }
        if (field) {
          return field;
        }
      }
      return null;
    }
    onRelationSearchTextChanged(fieldWithValue, relationSearchTextChangedData) {
      this.relationSearchTextChanged.next({
        fieldWithValue: fieldWithValue,
        relationSearchTextChangedData: relationSearchTextChangedData
      });
    }
    onAutocompleteSearchTextChanged(fieldWithValue, autocompleteSearchTexChangedData) {
      this.autocompleteSearchTextChanged.next({
        fieldWithValue: fieldWithValue,
        autocompleteSearchTextChangedData: autocompleteSearchTexChangedData
      });
    }
    onCellValueChanged(item, change) {
      this.grpFldsSvc.addChange(item, change, this.changes);
      this.setHasChanges();
      const obj = this.grpFldsSvc.createObjectFromChanges(this.changes);
      this.removeFromInvalidFieldsWithValues(item);
      this.valuesChanged.next({
        changedFieldWithValue: item,
        changes: this.changes,
        obj: obj
      });
    }
    onCellInvalidValueSet(item, change) {
      this.grpFldsSvc.setError(item.field, this.changes);
      this.setHasChanges();
      const obj = this.grpFldsSvc.createObjectFromChanges(this.changes);
      this.setToInvalidFieldsWithValues(item);
      this.valuesChanged.next({
        changedFieldWithValue: item,
        lastInvalidFieldWithValue: item,
        invalidFieldsWithValues: this.invalidFieldsWithValues,
        changes: this.changes,
        obj: obj
      });
      this.cdr.detectChanges();
    }
    setToInvalidFieldsWithValues(item) {
      const index = this.getExistingInvalidFieldWithValueIndex(item);
      if (index === -1) {
        this.invalidFieldsWithValues.push(item);
      } else {
        this.invalidFieldsWithValues[index] = item;
      }
      this.setHasError();
    }
    removeFromInvalidFieldsWithValues(item) {
      const index = this.getExistingInvalidFieldWithValueIndex(item);
      if (index === -1) {
        return;
      }
      this.invalidFieldsWithValues.splice(index, 1);
      this.setHasError();
    }
    getExistingInvalidFieldWithValueIndex(item) {
      if (!item || !item.field) {
        return -1;
      }
      const existing = this.invalidFieldsWithValues.findIndex(x => x.field.id === item.field.id);
      return existing;
    }
    onCroppedImageUploaded(item, args) {
      this.croppedImageUploaded.next({
        fieldWithValue: item,
        croppedArgs: args
      });
    }
    onDocumentSelected(item, args) {
      this.documentSelected.next({
        fieldWithValue: item,
        documentArgs: args
      });
    }
    onCancel() {
      this.changes = [];
      // Revert back to original data
      this.data.fieldsWithEntity = this.originalFieldsWithEntity;
      this.data.editModeForAllFields = false;
      this.dataChanged(this.data);
      this.setHasChanges();
      this.cancelled.next();
      this.forceAllFieldToBeTouched = false;
      this.invalidFieldsWithValues.splice(0);
      this.setHasError();
      this.cdr.detectChanges();
    }
    async onSave() {
      // Keep the original changes in case forcing all fields to be touched causes the fields to emit changes
      // which will unnecessary modify this.changes
      const originalChanges = this.changes.map(x => ({
        ...x
      }));
      // trigger valueChange on all the fields
      if (this.changes.length < this.data.fieldsWithEntity.fields.length) {
        this.forceAllFieldToBeTouched = true;
        this.data.editModeForAllFields = true;
      }
      // `invalidFieldsWithValues` should only be evaluated when all the child input-field elements finish the valueChange
      await firstValueFrom(this.ngZone.onStable);
      // Revert changes back to the original changes so we avoid emitting fields which were not actually changed by the user
      // but were changed by the automatic field validation above (this.forceAllFieldToBeTouched = true)
      this.changes = originalChanges;
      const isHavingInvalidValues = this.invalidFieldsWithValues?.length > 0;
      if (!isHavingInvalidValues) {
        const obj = this.grpFldsSvc.createObjectFromChanges(this.changes);
        this.saved.next({
          changedFieldWithValue: null,
          changes: this.changes,
          obj: obj
        });
      } else {
        this.scrollFirstErrorFieldIntoView(this.groups, this.invalidFieldsWithValues, this.groupsContainerElementRef.nativeElement);
      }
      this.setHasChanges();
    }
    scrollFirstErrorFieldIntoView(groups, invalidFieldsWithValues, groupsContainerEl) {
      const allInputFieldEls = Array.from(groupsContainerEl.querySelectorAll('azavista-input-field'));
      const invalidFieldWithValues = [];
      for (const inputFieldEl of allInputFieldEls) {
        const fieldId = inputFieldEl.getAttribute('field-id');
        const invalidField = invalidFieldsWithValues.find(x => x.field.id === fieldId);
        if (invalidField) {
          invalidFieldWithValues.push({
            fieldWithValue: invalidField,
            element: inputFieldEl
          });
        }
      }
      const orderedGroupedFields = groups.flatMap(x => x.items);
      for (const groupedField of orderedGroupedFields) {
        const invalidFieldWithValue = invalidFieldWithValues.find(x => x.fieldWithValue.field.id === groupedField.field.id);
        if (invalidFieldWithValue) {
          invalidFieldWithValue.element.scrollIntoView({
            block: 'center',
            inline: 'nearest'
          });
          break;
        }
      }
    }
    switchAllFieldsToEditMode() {
      if (this.editDisabled) {
        return;
      }
      this.data.editModeForAllFields = true;
    }
    setHasChanges() {
      this.hasChanges = this.changes.length > 0;
      this.setShowActionButtonsFlag();
    }
    setHasError() {
      this.data.hasError = this.externalErrorData?.hasError || this.invalidFieldsWithValues.length > 0;
      this.setShowActionButtonsFlag();
    }
    setShowActionButtonsFlag() {
      if (this.data.showActionButtons === false) {
        this.showActionButtons = false;
        return;
      }
      if (this.editDisabled) {
        this.showActionButtons = false;
        return;
      }
      if (this.data.hasError && this.data.showActionButtons !== true) {
        this.showActionButtons = false;
        return;
      }
      this.showActionButtons = this.data.showActionButtons || this.hasChanges;
    }
    ngOnDestroy() {
      this.subscriptions.forEach(x => x.unsubscribe());
    }
    /**
     * This method has side effect by updating `@param inputField`'s `isInvalid` property value
     */
    getDynamicFieldAndUpdateValidity(field, inputField) {
      const updatedEntity = {
        ...(this.data.fieldsWithEntity.entity || {}),
        ...this.grpFldsSvc.createObjectFromChanges(this.changes)
      };
      if (inputField.field) {
        updatedEntity[inputField.field.name] = inputField.value;
      }
      delay(500).then(() => {
        const iFieldWithValue = pick(inputField, ['field', 'value']);
        // we need to make sure this input field is updating its `isInvalid` without being inserted into `this.changes`
        // by preventing the emit of `valueChange` and `invalidValueChange`
        inputField.validateValueAndEmitIfError(inputField.lastValueChanged ?? inputField.value, true);
        if (inputField.isInvalid) {
          this.setToInvalidFieldsWithValues(iFieldWithValue);
        } else {
          this.removeFromInvalidFieldsWithValues(iFieldWithValue);
        }
      });
      return {
        ...field,
        ...field.customFieldByEntityValue(updatedEntity)
      };
    }
    static {
      this.ɵfac = function AzavistaGroupedFieldsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaGroupedFieldsComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(AzavistaGroupedFieldsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaGroupedFieldsComponent,
        selectors: [["azavista-grouped-fields"]],
        viewQuery: function AzavistaGroupedFieldsComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupsContainerElementRef = _t.first);
          }
        },
        inputs: {
          data: "data",
          acknowledgeEntity: "acknowledgeEntity",
          changeFieldValue: "changeFieldValue",
          acl: "acl",
          customSections: "customSections",
          setImageFieldData: "setImageFieldData",
          setDocumentFieldData: "setDocumentFieldData",
          actionButtonsDisabled: "actionButtonsDisabled",
          progressText: "progressText",
          fieldAppearance: "fieldAppearance",
          floatLabel: "floatLabel",
          setExternalError: "setExternalError",
          floatActions: "floatActions",
          performSave: "performSave"
        },
        outputs: {
          valuesChanged: "valuesChanged",
          cancelled: "cancelled",
          saved: "saved",
          relationSearchTextChanged: "relationSearchTextChanged",
          autocompleteSearchTextChanged: "autocompleteSearchTextChanged",
          croppedImageUploaded: "croppedImageUploaded",
          documentSelected: "documentSelected"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 10,
        vars: 6,
        consts: [["groupsContainer", ""], ["inputField", ""], [1, "panels-container", "aza-cmp-flex-column"], [3, "data"], ["class", "mat-elevation-z0", 3, "expanded", 4, "ngFor", "ngForOf"], ["class", "error-fields-container aza-cmp-margin", 4, "ngIf"], [1, "progress-text-container", "aza-cmp-half-margin"], ["class", "aza-cmp-triple-margin", 4, "ngIf"], ["class", "action-buttons-container aza-cmp-flex-row aza-cmp-margin", 3, "float-actions", 4, "ngIf"], [1, "mat-elevation-z0", 3, "expanded"], [1, "aza-group-title"], [1, "aza-cmp-grid"], [4, "ngFor", "ngForOf"], [3, "field", "value", "label", "showLabelInReadonlyMode", "showLabelForBooleans", "canEdit", "editMode", "fullWidth", "fieldAppearance", "options", "setImageFieldData", "setDocumentFieldData", "setTextFieldValue", "textAreaOptions", "floatLabel", "isTouched", "valueChanged", "relationSearchTextChanged", "autocompleteSearchTextChanged", "invalidValueSet", "editModeEntered", "croppedImageUploaded", "documentSelected", 4, "ngIf"], [4, "ngIf"], [3, "valueChanged", "relationSearchTextChanged", "autocompleteSearchTextChanged", "invalidValueSet", "editModeEntered", "croppedImageUploaded", "documentSelected", "field", "value", "label", "showLabelInReadonlyMode", "showLabelForBooleans", "canEdit", "editMode", "fullWidth", "fieldAppearance", "options", "setImageFieldData", "setDocumentFieldData", "setTextFieldValue", "textAreaOptions", "floatLabel", "isTouched"], [1, "error-fields-container", "aza-cmp-margin"], ["translate", "", 1, "error-field-message"], ["class", "error-field-name", 4, "ngFor", "ngForOf"], [1, "error-field-name"], [1, "error-field-message"], [1, "aza-cmp-triple-margin"], [1, "action-buttons-container", "aza-cmp-flex-row", "aza-cmp-margin"], ["color", "primary", 1, "save-button", 3, "click", "disabled"], [1, "cancel-button", 3, "click", "disabled"]],
        template: function AzavistaGroupedFieldsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2, 0);
            i0.ɵɵelement(2, "azavista-selected-items-count", 3);
            i0.ɵɵtemplate(3, AzavistaGroupedFieldsComponent_mat_expansion_panel_3_Template, 6, 11, "mat-expansion-panel", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, AzavistaGroupedFieldsComponent_div_4_Template, 4, 2, "div", 5);
            i0.ɵɵelementStart(5, "div", 6)(6, "span");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, AzavistaGroupedFieldsComponent_div_8_Template, 1, 0, "div", 7)(9, AzavistaGroupedFieldsComponent_div_9_Template, 11, 14, "div", 8);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("data", ctx.data == null ? null : ctx.data.selectedItemsCountData);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.groups);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.invalidFieldsWithValues == null ? null : ctx.invalidFieldsWithValues.length) > 0 || (ctx.externalErrorData == null ? null : ctx.externalErrorData.hasError));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.progressText);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.floatActions);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showActionButtons);
          }
        },
        dependencies: [i3.NgForOf, i3.NgIf, i4.TranslateDirective, i5.MatExpansionPanel, i5.MatExpansionPanelHeader, i5.MatExpansionPanelTitle, i6.AzavistaInputFieldComponent, i7.MatError, i8.AzavistaButtonComponent, i9.AzavistaSelectedItemsCountComponent, i3.UpperCasePipe, i4.TranslatePipe],
        styles: [".fields-container[_ngcontent-%COMP%]{grid-template-columns:1fr 1fr}.fields-container-single-column[_ngcontent-%COMP%]{grid-template-columns:1fr}.float-actions[_ngcontent-%COMP%]{position:fixed;bottom:0}.progress-text-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}"]
      });
    }
  }
  return AzavistaGroupedFieldsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaGroupedFieldsModule = /*#__PURE__*/(() => {
  class AzavistaGroupedFieldsModule {
    static {
      this.ɵfac = function AzavistaGroupedFieldsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaGroupedFieldsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaGroupedFieldsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AzavistaSharedModule, MatExpansionModule, AzavistaInputFieldModule, MatDividerModule, AzavistaButtonModule, AzavistaSelectedItemsCountModule]
      });
    }
  }
  return AzavistaGroupedFieldsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaGroupedFieldsComponent, AzavistaGroupedFieldsModule };
